import React, { useMemo } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { AddButton, ConfirmButtonArray } from '@td-client-frontend/common';
import { Add } from '@td-client-frontend/icons';
import { GroupInfo, GroupGridRowWithLabel, GroupGridRow } from '../GroupHelperComponents';
import { MaskInput, TextField } from '../../../components/ReactHookForm';
import { defaultMarketingContact } from '../../../utils/groups/incomingDataTransformation';

export const GroupContacts = () => {
  const { watch } = useFormContext();
  const marketingFields = watch('contacts.Marketing');

  const { fields, append, remove } = useFieldArray({
    name: 'contacts.Marketing'
  });

  const controlledFields = useMemo(() => {
    return fields.map((field, index) => {
      return {
        ...marketingFields[index],
        ...field
      };
    });
  }, [fields, marketingFields]);

  const handleAddContact = () => append(defaultMarketingContact);
  const handleRemoveContact = (index: number) => () => remove(index);

  return (
    <>
      <GroupInfo />
      <GroupGridRowWithLabel label="SAE">
        <TextField
          name="contacts.SAE.first"
          label="First Name"
          toolTip="The group administrator or main group contact."
          placeholder="Please enter first name"
          wrapperClasses="col-span-3"
          required
        />
        <TextField
          name="contacts.SAE.last"
          label="Last Name"
          wrapperClasses="col-span-3"
          placeholder="Please enter last name"
          required
        />
      </GroupGridRowWithLabel>
      <GroupGridRow>
        <MaskInput
          name="contacts.SAE.phone"
          label="Phone"
          placeholder="Please enter phone"
          additionalClasses="col-span-3"
        />
        <TextField
          name="contacts.SAE.email"
          label="Email"
          placeholder="Please enter email"
          wrapperClasses="col-span-3"
          required
        />
      </GroupGridRow>
      <GroupGridRowWithLabel label="Broker">
        <TextField
          name="contacts.Broker.first"
          toolTip="The broker or agency involved in the sale of the group."
          placeholder="Please enter first name"
          wrapperClasses="col-span-3"
          label="First Name"
        />
        <TextField
          name="contacts.Broker.last"
          placeholder="Please enter last name"
          wrapperClasses="col-span-3"
          label="Last Name"
        />
        <TextField
          name="contacts.Broker.company"
          label="Company Name"
          placeholder="Please enter company name"
          wrapperClasses="col-span-4"
        />
      </GroupGridRowWithLabel>
      <GroupGridRow>
        <MaskInput
          name="contacts.Broker.phone"
          label="Phone"
          placeholder="Please enter phone"
          additionalClasses="col-span-3"
        />
        <TextField
          name="contacts.Broker.email"
          label="Email"
          placeholder="Please enter email"
          wrapperClasses="col-span-3"
        />
      </GroupGridRow>
      <h3 className="pt-1 pb-6 font-effra font-medium">Marketing</h3>
      {controlledFields.map((field, index) => {
        return (
          <GroupGridRow key={field.id}>
            <TextField
              name={`contacts.Marketing.${index}.first`}
              toolTip="Contact(s) who should have access to utilization reports."
              placeholder="Please enter first name"
              wrapperClasses="col-span-3"
              label="First Name"
            />
            <TextField
              name={`contacts.Marketing.${index}.last`}
              label="Last Name"
              placeholder="Please enter last name"
              wrapperClasses="col-span-3"
            />
            <TextField
              name={`contacts.Marketing.${index}.email`}
              label="Email"
              placeholder="Please enter email"
              wrapperClasses="col-span-3"
            />
            <div className="col-span-1 flex items-center justify-center ">
              <ConfirmButtonArray
                id={`contacts.Marketing.${index}.remove`}
                entityName="some name"
                onClick={handleRemoveContact(index)}
              >
                <Add transform="rotate(45)" />
              </ConfirmButtonArray>
            </div>
          </GroupGridRow>
        );
      })}
      <AddButton label="Add contacts" onClick={handleAddContact} />
    </>
  );
};
